module.exports = __webpack_public_path__ + "static/img/songyimin.a0251f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/songyimin.png
// module id = ug5F
// module chunks = 0